<template>
  <div>
    <div v-if="image" class="grey lighten-4 elevation-4" style="position:relative;border-radius:50%" @click="dialog = true">
      <div class="avatar-update">
        <span>Change</span>
      </div>
      <img :src="image" style="max-width: 100%;border-radius:50%;width: 100%;">
    </div>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <form enctype="multipart/form-data" @submit.prevent="submitProfilePhotoChange">
          <v-card-title>
            <span class="headline">
              Update Profile Picture
            </span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <vue-cropper v-if="profilePhotoForm.data.profilePicFile" ref="cropper" guides :view-mode="2" drag-mode="crop" :zoom-on-wheel="false" :aspect-ratio="1/1" :auto-crop-area="0.5" :background="true" :src="profilePhotoForm.data.profilePicFile" alt="Source Image" :img-style="{ width: '400px', 'height': '300px' }" />
                  <input type="file" accept="image/*" placeholder="Profile Picture" @change="setProfileImage($event)">
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="accent" flat @click.native="dialog = false">
              Close
            </v-btn>
            <v-btn color="secondary" type="submit" :loading="profilePhotoForm.waiting">
              Update
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import VueCropper from 'vue-cropperjs';
  import axios from 'axios';

  export default {
    components: {
      VueCropper,
    },

    props: {
      image: String,
      imagePutEndpoint: String,
    },

    data: () => ({
      dialog: false,
      profilePhotoForm: {
        cropperExists: false,
        waiting: false,
        successNotif: false,
        error: {},
        data: {
          profilePicFile: '',
          profilePicCrop: '',
        },
      },
    }),

    methods: {
      setProfileImage(e) {
        const file = e.target.files[0];

        if (!file.type.includes('image/')) {
          alert('Please select an image file');
          return;
        }

        if (typeof FileReader === 'function') {
          const reader = new FileReader();

          reader.onload = (event) => {
            this.profilePhotoForm.data.profilePicFile = event.target.result;
            // rebuild cropperjs with the updated source
            if (this.profilePhotoForm.cropperExists) {
              this.$refs.cropper.replace(event.target.result);
            } else {
              this.profilePhotoForm.cropperExists = true;
            }
          };

          reader.readAsDataURL(file);
        } else {
          alert('Sorry, FileReader API not supported');
        }
      },

      async submitProfilePhotoChange() {
        this.profilePhotoForm.waiting = true;
        this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          const form = new FormData();
          form.append('File', blob);
          axios.put(this.imagePutEndpoint, form, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then(() => {
            this.profilePhotoForm.waiting = false;
            this.dialog = false;
            this.profilePhotoForm.cropperExists = false;
            this.profilePhotoForm.data.profilePicFile = '';
            this.profilePhotoForm.data.profilePicCrop = '';
            this.$emit('refresh');
          });
        });
      },

      fileReset() {
        this.submitCurriculumForm.file = null;
        const input = this.$refs.curriculumFileInput;
        input.type = 'text';
        input.type = 'file';
      },
    },
  };
</script>
